var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ts-datastore-dialog',{ref:"dialog",attrs:{"title":"Update Time Series Datastore","createLabel":"Update","instance":_vm.instance},on:{"payload":_vm.onPayload}})}
var staticRenderFns = []

export { render, staticRenderFns }